
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { AnnouncementBar, Header, Hero, Features, CTA, Subscribe, Footer , Cards, LoveAnalytics} from '../components';
import GlobalStyle from '../theme/GlobalStyle';
import theme from '../theme/theme';
import EmbeddedAnalyticsSection from '../components/Embeded/Embeded';
import TeamBISection from '../components/TeamBISection/TeamBISection';

function Main() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <Features />
        <EmbeddedAnalyticsSection/>
        <Cards />
        <TeamBISection/>
        <LoveAnalytics/>
        <CTA />
        <Subscribe />
      </main>
      <Footer />
    </ThemeProvider>
  );
}

export default Main;
